
import React from 'react';
import { PhoneNumberInput } from '@/components/invite-guests/phone-input/PhoneNumberInput';

interface PhoneEntryFormProps {
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  onSubmit: () => void;
  isProcessing: boolean;
  onBack: () => void;
  error: string | null;
}

export const PhoneEntryForm = ({
  phoneNumber,
  setPhoneNumber,
  onSubmit,
  isProcessing,
  onBack,
  error
}: PhoneEntryFormProps) => {
  return (
    <div className="w-full">
      <PhoneNumberInput
        value={phoneNumber}
        onChange={(value) => {
          setPhoneNumber(value);
        }}
        required
        centerAlign
      />
      
      {error && (
        <p className="text-sm text-destructive mt-2 text-center">{error}</p>
      )}
    </div>
  );
};
